import { useCallback } from 'react';
import type { IconName } from '@cbhq/cds-icons';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { ActionType, ComponentType, logEvent } from '@cbhq/client-analytics';

export type SettingsRowProps = {
  icon: IconName;
  title: string;
  description?: string;
  onClick: () => void;
  testID?: string;
};

export function SettingsRow({ icon, title, description, onClick, testID }: SettingsRowProps) {
  const handleClick = useCallback(() => {
    logEvent('settings_row_clicked', {
      componentType: ComponentType.button,
      action: ActionType.click,
      row_title: title,
    });
    onClick();
  }, [onClick, title]);

  return (
    <ListCell
      accessory="arrow"
      spacingVariant="condensed"
      media={<Icon name={icon} size="m" color="fg" />}
      title={title}
      description={description}
      onClick={handleClick}
      accessibilityLabel={title}
      testID={testID}
    />
  );
}
